'use strict'

module.exports = function whichModule (exported) {
  for (var i = 0, files = Object.keys(require.cache), mod; i < files.length; i++) {
    mod = require.cache[files[i]]
    if (mod.exports === exported) return mod
  }
  return null
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/yargs/node_modules/which-module/index.js
// module id = 186
// module chunks = 0